import {UI} from "../../../../../stem-core/ui/UIBase";
import {styleRule} from "../../../../../stem-core/ui/Style";

import {Messages} from "../../../../Messages.js";
import {
    Merchant,
    UserPreferences,
    Wallet
} from "../../../../State.js";
import {AutopayLimit} from "../components/AutopayLimit.jsx";
import {AutopaySetting} from "../components/AutopaySetting.jsx";
import {Toast} from "../../../../ui/Toast.jsx";
import {List, DividerPositions} from "../../../../ui/List.jsx";
import {IS_PRODUCTION} from "../../../../Constants.js";
import {BaseCard, BaseCardStyle} from "../../../../ui/BaseCard.jsx";
import {registerStyle} from "../../../../../stem-core/ui/style/Theme";
import {autoredraw} from "../../../../../stem-core/decorators/AutoRedraw";
import {apiUpdatePreferences} from "../../../../../client/state/UserPreferencesStore.js";
import {ToggleInput} from "../../../../../stem-core/ui/input/checkbox/ToggleInput.jsx";


class AutopayCardStyle extends BaseCardStyle {
    @styleRule
    list = {
        ">:first-child": {
            border: "none !important",
        }
    };
}

@registerStyle(AutopayCardStyle)
@autoredraw(UserPreferences, Wallet, Wallet)
export class AutopayCard extends BaseCard {
    getDefaultOptions() {
        return {
            ...super.getDefaultOptions(),
            title: Messages.autopay,
            description: Messages.autopayDefaultDescription,
            action: () => this.getActionButton(),
        };
    }

    getActionButton() {
        return <ToggleInput
            testId="autopayGlobalToggle"
            initialValue={this.autopayIsEnabled()}
            onChange={(value) => this.changeAutoPayEnabled(value)}
        />
    }

    render() {
        if (!this.autopayIsEnabled()) {
            return [];
        }

        let merchants = Merchant.getAutopayCompatibleMerchants();
        if (IS_PRODUCTION) {
            merchants = merchants.filter(merchant => !merchant.isFake);
        }

        return [
            <AutopayLimit testId="autopayLimit"/>,
            <List testId="autopayMerchantsList" dividerOptions={{position: DividerPositions.TOP}} className={this.styleSheet.list}>
                {merchants.map(merchant => <AutopaySetting merchant={merchant}/>)}
            </List>,
        ];
    }

    async changeAutoPayEnabled(autoPayEnabled) {
        try {
            await apiUpdatePreferences({autoPayEnabled});
            Toast.show(Messages.changesSaved); // TODO probably when we want to do this wrapper is should be a decorator @wrapInSpinner
        } catch (error) {
            Toast.showError(error, Messages.errorWhileSaving);
        }
    }

    autopayIsEnabled() {
        const preferences = UserPreferences.getPreferences();
        return preferences?.autoPayEnabled;
    }
}
